jQuery(document).ready(function($){
    $(".tteColorPicker").wpColorPicker({
        palettes: true,
        clear: true,
        alpha: true,
    });
});
